module.exports = __webpack_public_path__ + "img/search-white.afd422d1.svg";